(function ($, Drupal) {

  "use strict";

  // Mobile menu. Slicknav is being used.
  Drupal.behaviors.mobileMenu = {
    attach: function (context, settings) {

      const menu = $('.mobile-menu__wrapper');
      const openBtn = $('.mobile-menu__button--open');
      const closeBtn = $('.mobile-menu__button--close');

      menu.slicknav({
        label: '',
        duplicate: false,
        allowParentLinks: true,
        // nestedParentLinks: false,
        appendTo: '.header'
      });

      openBtn.click(() => {
        menu.slicknav('open');
        openBtn.hide();
        closeBtn.show();
      });

      closeBtn.click(() => {
        menu.slicknav('close');
        closeBtn.hide();
        openBtn.show();
      });
    }
  };

})(jQuery, Drupal);
